export default {
    // step 1
    login: null,
    password: null,
    terms: false,
    mailing: false,
    // step 2
    name: null,
    lastname: null,
    firstname: null,
    phone_country: 'fr',
    phone_number: null,
    country: 'FR',
    lang: 'fr',
    'g-recaptcha': null,
    utm_source: undefined,
    utm_medium: undefined,
    utm_campaign: undefined,
    google: null,
};
